import { render, staticRenderFns } from "./Endstops.vue?vue&type=template&id=218cd5b3&scoped=true&"
import script from "./Endstops.vue?vue&type=script&lang=js&"
export * from "./Endstops.vue?vue&type=script&lang=js&"
import style0 from "./Endstops.vue?vue&type=style&index=0&id=218cd5b3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "218cd5b3",
  null
  
)

export default component.exports